import request from './request'

export function curMonthNewUser(data) {
    return request({
        url: '/api/saleman/curMonthNewUser',
        method: 'get',
        params: data
    })
}

export function curMonthVisitUser(data) {
    return request({
        url: '/api/saleman/curMonthVisitUser',
        method: 'get',
        params: data
    })
}

export function unRevisitDoctorList(data) {
    return request({
        url: '/api/saleman/curMonthNoCreateFzCardUser',
        method: 'get',
        params: data
    })
}

export function unPackageDoctorList(data) {
    return request({
        url: '/api/saleman/curMonthNoCreateTaocanUser',
        method: 'get',
        params: data
    })
}

export function curMonthNoCreateFzCardUserPatientList(data) {
    return request({
        url: '/api/saleman/curMonthNoCreateFzCardUserPatientList',
        method: 'get',
        params: data
    })
}

export function curMonthNoCreateTaocanUserPatientList(data) {
    return request({
        url: '/api/saleman/curMonthNoCreateTaocanUserPatientList',
        method: 'get',
        params: data
    })
}